import { MalaPuscicaDol } from 'kzv-icons';
import { uniqBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import Button from '../buttons/Button';
import LoadingSpinner from '../LoadingSpinner';
import Poi from 'models/Poi';
import { Mixpanel } from 'utils/Mixpanel';
import PoiCardHorizontal from 'components/cards/poi/PoiCardHorizontal';

function NearbyPoisGrid({ lat, lng, exclude = [] }) {
    const [page, setPage] = useState(1);
    const [loadedPois, setLoadedPois] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, last: 10 });
    const [localLat, setLocalLat] = useState(lat);
    const [localLng, setLocalLng] = useState(lng);
    const [perPage, setPerPage] = useState(6);

    const maxPage = 10;
    const endpoint = '/public/pois/nearby';
    const params = {
        lat: localLat,
        lng: localLng,
        'page[size]': perPage.toString(),
        'page[number]': page.toString(),
        include: 'thumbs,type,areas',
        exclude: exclude.join(',')
    };

    const query = `${new URLSearchParams(params).toString()}`;
    const { data: nearbyPois, isValidating } = useSWR(endpoint + '?' + query);

    useEffect(() => {
        if (window.innerWidth > 1960 && perPage !== 8) {
            setPerPage(8);
        } else {
            if (perPage !== 6) setPerPage(6);
        }
    }, []);

    useEffect(() => {
        if (lat && lng) {
            setPage(1);
            setLoadedPois([]);
            setLocalLat(lat);
            setLocalLng(lng);
        }
    }, [lat, lng]);

    useEffect(() => {
        if (nearbyPois) {
            const data = nearbyPois.data;
            setPagination({ last: data.last_page, current: data.current_page });
            setLoadedPois((existing) => uniqBy([...existing, ...data], (poi) => poi.id));
        }
    }, [nearbyPois]);

    const loadMore = () => {
        if (page <= maxPage) {
            Mixpanel.track('Load more nearby pois');
            setPage(page + 1);
        }
    };

    return (
        <>
            <div className="grid gap-4 sm:grid-cols-2 md:gap-6 xl:grid-cols-3 3xl:grid-cols-4">
                {loadedPois.map((poi: Poi) => {
                    const elevation = poi.attributes.find((attr) => attr.attribute?.slug === 'nadmorska-visina');
                    const label = elevation ? `${elevation.value} ${elevation.attribute.unit}` : '';

                    return <PoiCardHorizontal key={poi.id} poi={poi} label={label} />;
                })}
            </div>
            <div className="text-center mt-6">
                {page <= maxPage && (
                    <Button
                        disabled={isValidating}
                        color="secondary"
                        endIcon={isValidating ? <LoadingSpinner /> : <MalaPuscicaDol strokeWidth={2} />}
                        onClick={loadMore}
                        outerStyles={pagination.current >= pagination.last ? 'invisible' : ''}>
                        Naloži več
                    </Button>
                )}
            </div>
        </>
    );
}

NearbyPoisGrid.propTypes = {};

export default NearbyPoisGrid;
